export const DeliveryRunsResource = {
  name: "Delivery Runs",
  path: "/fleets/settings/delivery-runs",
  access: ["read-deliveryRuns"],
};
